import { Loader, Center, Overlay } from '@mantine/core';

export default function LoadingSpinner({ fullScreen = false, size = 'md' }) {
  const mantineSize = size === 'lg' ? 'lg' : size === 'sm' ? 'xs' : 'sm';

  if (fullScreen) {
    return (
      <Overlay color="#fff" backgroundOpacity={0.9} zIndex={200}>
        <Center h="100vh">
          <Loader size={mantineSize} color="aviary" />
        </Center>
      </Overlay>
    );
  }

  return (
    <Center h={200}>
      <Loader size={mantineSize} color="aviary" />
    </Center>
  );
}
